import type { CSSProperties } from 'react';
import config from '../../../config.json';
import { legalButtonBase, legalTitleStyle } from './legalPageStyles';

type GoogleDocEmbedErrorProps = {
  publishedUrl: string;
};

const bodyText: CSSProperties = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '26px',
  color: 'rgba(255, 255, 255, 0.9)',
  margin: 0,
};

export const GoogleDocEmbedError = ({ publishedUrl }: GoogleDocEmbedErrorProps) => {
  return (
    <div
      data-testid='legal-doc-embed-error'
      style={{
        width: '100%',
        minHeight: 'calc(100vh - 200px)',
        boxSizing: 'border-box',
        padding: '8px 0 48px',
        background: 'transparent',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textAlign: 'center',
      }}
    >
      <h2
        className='mb-4 max-w-[320px] text-[32px] leading-[38px] lg:max-w-none lg:text-[28px] lg:leading-[36px]'
        style={legalTitleStyle}
      >
        Oops —
        <br className='lg:hidden' /> this one didn&apos;t load.
      </h2>
      <p className='mb-7 max-w-[320px] lg:max-w-none' style={bodyText}>
        Looks like it messed up — check it out directly!
      </p>
      <div className='flex w-full max-w-[320px] flex-col items-center gap-3 lg:max-w-none lg:flex-row lg:justify-center lg:gap-3'>
        <a
          href={publishedUrl}
          target='_blank'
          rel='noopener noreferrer'
          data-testid='legal-doc-direct-link'
          className='aida-button'
          style={{ ...legalButtonBase, fontSize: '13px', padding: '8px 20px', background: '#FBBF24', color: '#161423' }}
        >
          <span className='text'>Open the document directly</span>
        </a>
        <a
          href={config.DISCORD_URL}
          target='_blank'
          rel='noopener noreferrer'
          data-testid='legal-doc-discord-link'
          className='aida-button aida-button-outline-fill'
          style={{ ...legalButtonBase, fontSize: '13px', padding: '8px 20px' }}
        >
          <span className='text'>Get help on Discord</span>
        </a>
      </div>
    </div>
  );
};
